export function ingredientSearchResult(name, { group = false } = {}) {
    const groupBadge = group
        ? `<div class="ml-2 self-center rounded-full bg-warm-gray-100 px-2 py-0.5 text-[11px] font-medium leading-none text-warm-gray-600 whitespace-nowrap">
               Group &middot; all forms
           </div>`
        : ""

    return `<div class="py-3 flex font-header border-b border-blue-gray-50 w-full">
                    <div class='flex flex-wrap py-1.5'>
                        <div class="text-blue-gray-800 font-medium leading-none pt-0.5">
                          ${name}
                        </div>
                        ${groupBadge}
                    </div>
                </div>`
}
